import { VueConstructor } from 'vue'
import Buefy from 'buefy'
import moment from 'moment'

export function installVue2Buefy(Vue: VueConstructor) {
    Vue.use(Buefy, {
        defaultDayNames: [
            'Dom',
            'Seg',
            'Ter',
            'Qua',
            'Qui',
            'Sex',
            'Sab'
        ],
        defaultMonthNames: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ],
        defaultDatepickerMobileNative: false,
        defaultDateParser: (date: string) => {
            const m = moment(date, 'DD/MM/YYYY')
            return m.isValid() ? m.toDate() : null
        }
    })
}
